import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Button, Divider, Modal, Radio, Row, Space } from "antd";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import PageContainer from "../layout/PageContainer";
import IconDelete from "../assets/images/icon_delete.png";
import styles from "./ReturnCheckList.module.css";

// import ModalConfirmPenaltyPayment from "../components/ModalConfirmPenaltyPayment";

type TypeReturnCategoryItem = { isExist: boolean; category: Types.RentPaymentCategoryDto };

function ReturnCheckList() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();
    const [rent, setRent] = useState<Types.RentDto>();
    const [paymentCategories, setPaymentCategories] = useState<Array<Types.RentPaymentCategoryDto>>();

    const [paymentCheckList, setPaymentCheckList] = useState<Array<TypeReturnCategoryItem>>([]);

    // const [openModalConfirmPayments, setOpenModalConfirmPayments] = useState(false);

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
    }, [params.rentId]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        Utils.onEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);

        Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);

        if (currentRentId) {
            requestGetPaymentCategories();
            requestGetRent();
            // requestGetPaymentItems();
        }

        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
            Utils.offEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        };
    }, [currentRentId]);

    const handleCloseAllModal = () => {
        Modal.destroyAll();
        // setOpenModalConfirmPayments(false);
    };

    const requestAxiosGetRent = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + currentRentId);
        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;
        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    const requestAxiosGetPaymentCategories = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_PAYMENT_CATEGORIES_URL);
        return response.data;
    };

    const {
        loading: loadingGetPaymentCategories,
        error: errorGetPaymentCategories,
        data: resultGetPaymentCategories,
        execute: requestGetPaymentCategories,
    } = useAsyncAxios(requestAxiosGetPaymentCategories);

    useEffect(() => {
        if (resultGetPaymentCategories === null) return;
        console.log("resultGetPaymentCategories", resultGetPaymentCategories);
        setPaymentCategories(resultGetPaymentCategories.rentPaymentCategories);
    }, [resultGetPaymentCategories]);

    useEffect(() => {
        if (errorGetPaymentCategories === null) return;
        console.log("errorGetPaymentCategories", errorGetPaymentCategories);
    }, [errorGetPaymentCategories]);

    useEffect(() => {
        const tempCheckList: TypeReturnCategoryItem[] = [];
        paymentCategories?.forEach((category) => {
            let exist = false;
            if (rent !== undefined && rent !== null) {
                if (
                    rent.rentPayments.find(
                        (payment) => payment.rentPaymentItem?.rentPaymentCategory?.rentPaymentCategoryId === category.rentPaymentCategoryId
                    ) !== undefined
                ) {
                    exist = true;
                }
            }
            tempCheckList.push({ isExist: exist, category: category });
        });
        setPaymentCheckList(tempCheckList);
    }, [paymentCategories]);

    useEffect(() => {
        if (rent !== undefined && rent !== null) {
            if (paymentCheckList.length > 0) {
                const tempCheckList = [...paymentCheckList];
                tempCheckList.forEach((check) => {
                    if (
                        rent.rentPayments.find(
                            (payment) => payment.rentPaymentItem?.rentPaymentCategory?.rentPaymentCategoryId === check.category.rentPaymentCategoryId
                        ) !== undefined
                    ) {
                        check.isExist = true;
                    } else check.isExist = false;
                });

                setPaymentCheckList(tempCheckList);
            }
        }
    }, [rent]);

    const onDeletePayment = (rentPaymentId: number) => {
        showDeleteConfirm(rentPaymentId);
    };

    const showDeleteConfirm = (rentPaymentId: number) => {
        Utils.addModalStack();
        Modal.confirm({
            title: "결제 삭제",
            content: "결제를 삭제하시겠습니까?",
            okText: "확인",
            onOk() {
                Utils.popModalStack();
                requestDeletePayment(rentPaymentId);
            },
            cancelText: "취소",
            onCancel() {
                Utils.popModalStack();
            },
            centered: true,
        });
    };

    const requestAxiosDeletePayment = async (rentPaymentId: number) => {
        const response = await utilAxiosWithAuth().delete(Request.RENT_PAYMENT_URL + rentPaymentId);
        return response.data;
    };

    const {
        loading: loadingDeletePayment,
        error: errorDeletePayment,
        data: resultDeletePayment,
        execute: requestDeletePayment,
    } = useAsyncAxios(requestAxiosDeletePayment);

    useEffect(() => {
        if (resultDeletePayment === null) return;
        console.log("resultDeletePayment", resultDeletePayment);
        currentRentId && requestGetRent();
    }, [resultDeletePayment]);

    useEffect(() => {
        if (errorDeletePayment === null) return;
        console.log("errorDeletePayment", errorDeletePayment);
    }, [errorDeletePayment]);

    // const requestAxiosGetPaymentItems = async () => {
    //     const response = await utilAxiosWithAuth().get(Request.RENT_PAYMENT_ITEMS_URL);
    //     return response.data;
    // };

    // const {
    //     loading: loadingGetPaymentItems,
    //     error: errorGetPaymentItems,
    //     data: resultGetPaymentItems,
    //     execute: requestGetPaymentItems,
    // } = useAsyncAxios(requestAxiosGetPaymentItems);

    // useEffect(() => {
    //     if (resultGetPaymentItems === null) return;
    //     console.log("resultGetPaymentItems", resultGetPaymentItems);
    // }, [resultGetPaymentItems]);

    // useEffect(() => {
    //     if (errorGetPaymentItems === null) return;
    //     console.log("errorGetPaymentItems", errorGetPaymentItems);
    // }, [errorGetPaymentItems]);

    // const onReturnRent = () => {
    //     requestReturnRent();
    // };

    // const requestAxiosReturnRent = async () => {
    //     const response = await utilAxiosWithAuth().put(Request.RENT_URL + currentRentId + Request.RENT_RETURN_URL);
    //     return response.data;
    // };

    // const {
    //     loading: loadingReturnRent,
    //     error: errorReturnRent,
    //     data: resultReturnRent,
    //     execute: requestReturnRent,
    // } = useAsyncAxios(requestAxiosReturnRent);

    // useEffect(() => {
    //     if (resultReturnRent === null) return;
    //     console.log("resultReturnRent", resultReturnRent);
    //     navigate(Common.PAGE_RENT_DETAIL + "/" + currentRentId);
    // }, [resultReturnRent]);

    // useEffect(() => {
    //     if (errorReturnRent === null) return;
    //     console.log("errorReturnRent", errorReturnRent);
    // }, [errorReturnRent]);

    const goToNextProcess = () => {
        // requestUpdateRentPayment();
        navigate(Common.PAGE_RETURN_RESULT_PAYMENT + "/" + currentRentId);
    };

    // const {
    //     loading: loadingUpdateRentPayment,
    //     error: errorUpdateRentPayment,
    //     data: resultUpdateRentPayment,
    //     execute: requestUpdateRentPayment,
    // } = useAsyncAxios(requestAxiosGetRent);

    // useEffect(() => {
    //     if (resultUpdateRentPayment === null) return;
    //     console.log("resultUpdateRentPayment", resultUpdateRentPayment);
    //     setRent(resultUpdateRentPayment.rent);

    //     setOpenModalConfirmPayments(true);
    // }, [resultUpdateRentPayment]);

    // useEffect(() => {
    //     if (errorUpdateRentPayment === null) return;
    //     console.log("errorUpdateRentPayment", errorUpdateRentPayment);
    // }, [errorUpdateRentPayment]);

    const onChangeExist = (rentPaymentCategoryId: number, checked: boolean) => {
        const tempCheckList = [...paymentCheckList];
        const tempItem = tempCheckList.find((item) => item.category.rentPaymentCategoryId === rentPaymentCategoryId);
        tempItem && (tempItem.isExist = checked);

        setPaymentCheckList(tempCheckList);
    };

    const goToAddPaymentItems = (rentPaymentCategory: Types.RentPaymentCategoryDto) => {
        // if (rentPaymentCategory.rentPaymentCategoryName.includes("반납 지연")) {
        //     navigate(Common.PAGE_RETURN_ADD_DELAYED_ARRIVE_PAYMENT_ITEM + "/" + currentRentId + "/" + rentPaymentCategory.rentPaymentCategoryId);
        // } else if (rentPaymentCategory.rentPaymentCategoryName.includes("배터리 미충전")) {
        //     navigate(Common.PAGE_RETURN_ADD_BATTERY_PAYMENT_ITEM + "/" + currentRentId + "/" + rentPaymentCategory.rentPaymentCategoryId);
        // } else {
        //     navigate(Common.PAGE_RETURN_ADD_NORMAL_PAYMENT_ITEM + "/" + currentRentId + "/" + rentPaymentCategory.rentPaymentCategoryId);
        // }

        navigate(Common.PAGE_RETURN_ADD_PAYMENT_ITEM + "/" + currentRentId + "/" + rentPaymentCategory.rentPaymentCategoryId);
    };

    const displayPaymentCategories = () => {
        return paymentCheckList.length > 0
            ? paymentCheckList.map((check, index) => {
                  let paymentList: Types.RentPaymentDto[] = [];
                  if (rent !== undefined && rent.rentPayments !== undefined) {
                      paymentList = rent.rentPayments.filter(
                          (payment) =>
                              (payment.rentPaymentType === "PENALTY" || payment.rentPaymentType === "INSURANCE") &&
                              payment.rentPaymentItem.rentPaymentCategory.rentPaymentCategoryId === check.category.rentPaymentCategoryId
                      );
                  }
                  return (
                      <div key={check.category.rentPaymentCategoryId}>
                          <Space direction="vertical" size={10} style={{ width: "100%", marginTop: 0 }} key={check.category.rentPaymentCategoryId}>
                              <Row align="middle" justify="space-between">
                                  <h3 className={styles.subTitle}>{check.category.rentPaymentCategoryName}</h3>
                                  <Button onClick={() => goToAddPaymentItems(check.category)}>추가</Button>
                              </Row>
                              <Radio.Group
                                  onChange={(e) => onChangeExist(check.category.rentPaymentCategoryId, e.target.value)}
                                  value={check.isExist}
                              >
                                  <Radio disabled value={true}>
                                      있음
                                  </Radio>
                                  <Radio disabled value={false}>
                                      없음
                                  </Radio>
                              </Radio.Group>
                              {/* {check.isExist && <Button onClick={() => goToAddPaymentItems(check.category.rentPaymentCategoryId)}>수정</Button>} */}
                              {paymentList.length > 0 && (
                                  <div className={styles.box} style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                      {paymentList.map((payment) => {
                                          return (
                                              <Row key={payment.rentPaymentId} align="middle" justify="space-between" style={{ width: "100%" }}>
                                                  {payment.rentPaymentItem.rentPaymentItemName}
                                                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                      {Utils.convertCurrencyKorean(payment.amount)}
                                                      <img
                                                          src={IconDelete}
                                                          width={16}
                                                          height={16}
                                                          onClick={() => onDeletePayment(payment.rentPaymentId)}
                                                      />
                                                  </div>
                                              </Row>
                                          );
                                      })}
                                  </div>
                              )}
                          </Space>
                          {paymentCheckList.length !== index + 1 && <Divider className={styles.divider} />}
                      </div>
                  );
              })
            : null;
    };

    return (
        <PageContainer>
            {displayPaymentCategories()}
            {/* {rent && (
                <ModalConfirmPenaltyPayment
                    open={openModalConfirmPayments}
                    rentPayments={rent.rentPayments}
                    onChangedOpen={(open: boolean) => {
                        setOpenModalConfirmPayments(open);
                    }}
                    onConfirmed={() => {
                        onReturnRent();
                        setOpenModalConfirmPayments(false);
                    }}
                />
            )} */}
        </PageContainer>
    );
}

export default ReturnCheckList;
